module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/giftcard-6a5b56220adf5e56c899eb697a9a03e6.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/giftcard.svg
// module id = 7tSX
// module chunks = 24